import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../ui/card';
import { Input } from '../../../ui/input';
import { Label } from '../../../ui/label';

export default function FinancialRatioSection() {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg text-blue-600">Rasio Keuangan Calon Debitur</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid gap-4">
          {/* Row 1 */}
          <div className="grid md:grid-cols-3 gap-4">
            <div className="space-y-2">
              <Label className="text-sm text-gray-600">DSCR (Debt Service Coverage Ratio)</Label>
              <Input
                type="text"
                value="696.58%"
                readOnly
                className="text-right bg-gray-50 font-semibold"
              />
            </div>
            <div className="space-y-2">
              <Label className="text-sm text-gray-600">Debt To Income</Label>
              <Input
                type="text"
                value="4.02%"
                readOnly
                className="text-right bg-gray-50 font-semibold"
              />
            </div>
            <div className="space-y-2">
              <Label className="text-sm text-gray-600">Net Profit Margin</Label>
              <Input
                type="text"
                value="22.11%"
                readOnly
                className="text-right bg-gray-50 font-semibold"
              />
            </div>
          </div>

          {/* Row 2 */}
          <div className="grid md:grid-cols-3 gap-4">
            <div className="space-y-2">
              <Label className="text-sm text-gray-600">Collateral Coverage Ratio</Label>
              <Input
                type="text"
                value="360.44%"
                readOnly
                className="text-right bg-gray-50 font-semibold"
              />
            </div>
            <div className="space-y-2">
              <Label className="text-sm text-gray-600">DAR (Debt to Asset Ratio)</Label>
              <Input
                type="text"
                value="13.15%"
                readOnly
                className="text-right bg-gray-50 font-semibold"
              />
            </div>
            <div className="space-y-2">
              <Label className="text-sm text-gray-600">DER (Debt to Equity Ratio)</Label>
              <Input
                type="text"
                value="16.28%"
                readOnly
                className="text-right bg-gray-50 font-semibold"
              />
            </div>
          </div>

          {/* Row 3 */}
          <div className="grid md:grid-cols-3 gap-4">
            <div className="space-y-2">
              <Label className="text-sm text-gray-600">Repayment Capacity Dari Net Cash Flow</Label>
              <Input
                type="text"
                value="14.83%"
                readOnly
                className="text-right bg-gray-50 font-semibold"
              />
            </div>
            <div className="space-y-2">
              <Label className="text-sm text-gray-600">ROA (Return to Asset Ratio)</Label>
              <Input
                type="text"
                value="47.9%"
                readOnly
                className="text-right bg-gray-50 font-semibold"
              />
            </div>
            <div className="space-y-2">
              <Label className="text-sm text-gray-600">ROE (Return to Equity Ratio)</Label>
              <Input
                type="text"
                value="59.28%"
                readOnly
                className="text-right bg-gray-50 font-semibold"
              />
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
